import { useSnapshot } from 'valtio';
import useCepFormGoalGroupConfig
  from './CepFormGoalGroup.config';
import useGetCepEngagementQuery from 'basics/graphql/queries/getCepEngagement';
import useGetCepReachQuery from 'basics/graphql/queries/getCepReach';
import { CepStateType } from 'basics/types/maya.types';
import cepState from 'states/cep.states';

const useCepFormGoalGroup = () => {
  const cepStateValue = useSnapshot(cepState) as CepStateType;

  const { cepEngagement, loading: engagementLoading } = useGetCepEngagementQuery(cepStateValue.cep?._id);
  const { cepReach, loading: reachLoading } = useGetCepReachQuery(cepStateValue.cep?._id);

  const { cepFormGoalGroup } = useCepFormGoalGroupConfig(cepEngagement, cepReach);

  return {
    cepFormGoalGroup,
    engagementLoading,
    reachLoading,
  };
};

export default useCepFormGoalGroup;
